var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "h-full",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.729 11.2967H23.8186V11.25H13.6465V15.75H20.034C19.1021 18.3696 16.5981 20.25 13.6465 20.25C9.90149 20.25 6.86512 17.2277 6.86512 13.5C6.86512 9.77231 9.90149 6.75 13.6465 6.75C15.3752 6.75 16.9479 7.39912 18.1454 8.45943L21.3423 5.27737C19.3237 3.40481 16.6235 2.25 13.6465 2.25C7.4048 2.25 2.34419 7.28718 2.34419 13.5C2.34419 19.7128 7.4048 24.75 13.6465 24.75C19.8882 24.75 24.9488 19.7128 24.9488 13.5C24.9488 12.7457 24.8709 12.0094 24.729 11.2967Z",
    fill: "#FFC107"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.64735 8.26368L7.36073 10.9744C8.3655 8.49825 10.7989 6.75 13.6465 6.75C15.3752 6.75 16.9479 7.39912 18.1454 8.45943L21.3423 5.27737C19.3237 3.40481 16.6235 2.25 13.6465 2.25C9.30529 2.25 5.54049 4.68956 3.64735 8.26368Z",
    fill: "#FF3D00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6465 24.75C16.5659 24.75 19.2186 23.6379 21.2242 21.8295L17.7261 18.8831C16.5913 19.7387 15.1808 20.25 13.6465 20.25C10.7068 20.25 8.21066 18.3842 7.27031 15.7804L3.58462 18.6069C5.45516 22.2503 9.25387 24.75 13.6465 24.75Z",
    fill: "#4CAF50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.729 11.2967H23.8186V11.25H13.6465V15.75H20.034C19.5865 17.0083 18.7733 18.0934 17.7244 18.8837C17.725 18.8831 17.7255 18.8831 17.7261 18.8826L21.2242 21.8289C20.9766 22.0528 24.9488 19.125 24.9488 13.5C24.9488 12.7457 24.8709 12.0094 24.729 11.2967Z",
    fill: "#1976D2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google_icon.918666c12a6c1b9bffb58d728225259e.svg";
export { ForwardRef as ReactComponent };